import { enhance, handle } from "@grrr/hansel";
import { onDomReady } from "@grrr/ready";
import { svgInline } from "./modules/svg";
import { ticker } from "./modules/ticker";
import { backToTop, toAnchor } from "./modules/scroll_links";
import { contact } from "./modules/contact";
import { menu } from "./modules/menu";
import { menuIndices } from "./modules/menu_indices";
import { followLinkAttribute } from "./modules/follow_link_attribute";
import { veemLogo } from "./modules/veem_logo";
import { hover } from "./modules/hover";
import { carrouselEnhancer, downloads, staff } from "./modules/carrousel";
import { imageEffect } from "./modules/image_effect";
import { searchArchive } from "./modules/search_archive";
import { icon } from "./modules/icon";
import { iframeEnhancer } from "./modules/iframe";
import { autoLoad } from "./modules/autoload";
import "./vendor/shadowllax";
import { newsLetter } from "./modules/newsletter";
import { backgroundEnhancer } from "./modules/background";
import { donateOnce, donatePlan } from "./modules/donate";

onDomReady(() => {
    enhance(document.documentElement, {
        svgInline,
        ticker,
        contact,
        menu,
        icon,
        menuIndices,
        veemLogo,
        iframeEnhancer,
        autoLoad,
        hover,
        carrouselEnhancer,
        downloads,
        staff,
        imageEffect,
        searchArchive,
        newsLetter,
        backgroundEnhancer,
    });
    handle(document.documentElement, {
        backToTop,
        followLinkAttribute,
        toAnchor,
        donatePlan,
        donateOnce,
    });
});
